import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlansComponent } from './plans.component';
import { MembersPlanComponent } from './members-plan/members-plan.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: PlansComponent, data: { title: 'Planes Conectimed' } },
  { path: 'members/:id', component: MembersPlanComponent, data: { title: 'Miembros en plan' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PlnasRoutingModule { }
